import useUrl from './helpers/useUrl'

/** @param {import("@nuxtjs/axios").NuxtAxiosInstance} client */
export default (client) => {
  const root = useUrl('service_status')

  return {
    /** @returns {Promise<AxiosResponse<GetServiceStatusResponse>>} */
    getServiceStatus() {
      const url = root('')
      return client.get(url)
    },
  }
}

/** @typedef {object} GetServiceStatusResponse
  * @prop {string} status
  * @prop {string} date */
